import { render } from "./PageLoader.vue?vue&type=template&id=ba6b6bcc&scoped=true"
import script from "./PageLoader.vue?vue&type=script&lang=js"
export * from "./PageLoader.vue?vue&type=script&lang=js"

import "./PageLoader.vue?vue&type=style&index=0&id=ba6b6bcc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ba6b6bcc"

export default script